/**
 * Where each dataset's records end up in the UI.
 *
 * The import job knows its dataset; the navbar and the page tabs need to know
 * whether *they* are the destination. This is the one place that mapping
 * lives, so adding a dataset means adding a line here rather than touching
 * either consumer.
 *
 * Routes are a list because a dataset can surface on more than one page.
 */

interface DatasetLocation {
  /** Navbar route paths where this dataset's records appear. */
  routes: string[];
  /** Tab key within those pages, when the page has tabs. */
  tabKey?: string;
}

export const DATASET_LOCATIONS: Record<string, DatasetLocation> = {
  utilities: { routes: ['/facilities'], tabKey: 'utilities' },
  refrigerants: { routes: ['/facilities'], tabKey: 'refrigerants' },
  waste: { routes: ['/facilities'], tabKey: 'waste' },
  fuel: { routes: ['/facilities'], tabKey: 'fuel' },
  travel: { routes: ['/travel'] },
  freight: { routes: ['/shipments'] },
  recipes: { routes: ['/products'] },
  purchases: { routes: ['/purchases'] },
  sales: { routes: ['/sales'] },
};

/** Dataset keys whose records land on the given route. */
export function datasetsForRoute(path: string): string[] {
  return Object.entries(DATASET_LOCATIONS)
    .filter(([, location]) => location.routes.includes(path))
    .map(([key]) => key);
}

/** Dataset keys whose records land on the given tab. */
export function datasetsForTab(tabKey: string): string[] {
  return Object.entries(DATASET_LOCATIONS)
    .filter(([, location]) => location.tabKey === tabKey)
    .map(([key]) => key);
}
